import { CategoryGetters, AgnosticCategoryTree } from '@vue-storefront/core';
import type { Category } from '@bee-hole/api';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getTree(category: Category): AgnosticCategoryTree {
  return {
    label: '',
    slug: '',
    items: [],
    isCurrent: false
  };
}

function getSlug(category: Category): string {
  // return "-";
  let x = category?.slug?.replace(/\//g, '-') || category?.name?.replace(/\//g, '-');
  return x.replace(/\s+/g, '-').toLowerCase();
}

export const categoryGetters: CategoryGetters<Category> = {
  getTree,
  getSlug
};
